import "./header_checkout.css";
import { Lock } from "lucide-react";

export function HeaderCheckout() {
  return (
    <header className="checkout-header">
      <div className="checkout-logo-container">
        <a href="/" title="Domínio Elétrico" className="checkout-logo-link">
          <img
            src="/dominio_eletrico_logo_2023_square_fundo_transparente.png"
            alt="Logo do Domínio Elétrico"
            className="checkout-logo"
          />
        </a>
      </div>

      <div className="checkout-security-badge">
        <Lock size={18} />
        <div className="checkout-security-text">
          <span className="checkout-security-title">
            Pagamento Seguro
          </span>
          <span className="checkout-security-subtitle">
            Ambiente protegido por criptografia SSL
          </span>
        </div>
      </div>
    </header>
  );
}